export function isPasskeyDialogCancel(error: unknown): boolean {
  const name = readErrorName(error);
  return name === 'NotAllowedError' || name === 'AbortError';
}

export function getPasskeyFailureMessage(payload: unknown, fallback: string): string {
  if (!payload || typeof payload !== 'object') return fallback;

  const record = payload as Record<string, unknown>;
  const nestedError = record.error;
  const nestedMessage =
    nestedError && typeof nestedError === 'object'
      ? (nestedError as Record<string, unknown>).message
      : nestedError;

  const candidates = [record.message, nestedMessage, record.error];
  const message = candidates.find((candidate) => typeof candidate === 'string' && candidate.trim());

  return typeof message === 'string' ? message : fallback;
}

export function shouldClearLocalPasskeyFromServerFailure(status: number, message: string): boolean {
  const normalized = normalizeFailureText(message);
  if (status === 404 || status === 410) return true;

  return (
    status === 400 &&
    /passkey|credencial|credential|chave/.test(normalized) &&
    /nao encontrada|invalida|invalid|revogada|revoked|unknown|not found|nenhuma.*(passkey|credencial|credential|chave)|disponi[iv]el/.test(normalized)
  );
}

function readErrorName(error: unknown): string {
  if (!error || typeof error !== 'object') return '';
  const name = (error as { name?: unknown }).name;
  return typeof name === 'string' ? name : '';
}

function normalizeFailureText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}
